import { render } from "./PageUpdateDataKeputusan.vue?vue&type=template&id=20b7a798"
import script from "./PageUpdateDataKeputusan.vue?vue&type=script&lang=js"
export * from "./PageUpdateDataKeputusan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__